import { WpActivity } from './wp-activity.model';
import { WpEtEnrollment } from './wp-et-enrollment.model';

export class ActivitySummary {
  constructor(
        public referralId?: string,
        public personId?: number,
        public wpEtEnrollment?: WpEtEnrollment,
        public wpActivity?: WpActivity,
        public wpActivities?: WpActivity[],
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/activity-summary.model.ts